import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { IdLabelDto, LabelType } from '@/services/ws-labels/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import type { Option } from 'src/types';
import { useLabelsOptions } from '../hooks/useLabelsOptions';

interface LabelsFilterProps {
  type: LabelType;
  value: Option<IdLabelDto>[];
  onChange: (value: Option<IdLabelDto>[]) => void;
  label?: string;
  dataTestId?: string;
}

export const LabelsFilter = memo(function LabelsFilter({ type, value, onChange, label, dataTestId }: LabelsFilterProps) {
  const [t] = useTranslation(['backend', 'common']);
  const { options, pending } = useLabelsOptions(type);

  const handleChange = useCallbackRef((newValue: Option<IdLabelDto>[]) => {
    onChange(newValue);
  });

  return (
    <Filter<IdLabelDto>
      label={label ?? t('common:LABELS')}
      loading={pending}
      selected={value}
      onChange={handleChange}
      dataTestId={dataTestId ?? 'labels-dropdown'}
      options={options}
      isMulti
    />
  );
});
